import { TYPE, url } from 'Reducers/s3Config';
import { get } from 'Server';

export const fetchEscrowConfiguration = () => dispatch => {
    return dispatch(get(url.escrowConfig, TYPE.escrowConfigType));
};
